import React from 'react';
import { StyledButton } from './ButtonStyles';

const Button = () => <StyledButton>Dodaj</StyledButton>;

export default Button;
